/**
 * Business-facing status labels (PRODUCT.md §9.1): internal enums are never
 * shown raw — every known status gets a localized label, unknown values fall
 * back to a prettified string instead of leaking snake_case identifiers.
 */
const LABELS: Record<string, { "zh-CN": string; en: string }> = {
  succeeded: { "zh-CN": "成功", en: "Succeeded" },
  failed: { "zh-CN": "失败", en: "Failed" },
  pending_reconciliation: { "zh-CN": "待对账", en: "Pending reconciliation" },
  processing: { "zh-CN": "处理中", en: "Processing" },
  reconciling: { "zh-CN": "对账中", en: "Reconciling" },
  active: { "zh-CN": "启用中", en: "Active" },
  revoked: { "zh-CN": "已撤销", en: "Revoked" },
  disabled: { "zh-CN": "已停用", en: "Disabled" },
  enabled: { "zh-CN": "已启用", en: "Enabled" },
  requested: { "zh-CN": "已申请", en: "Requested" },
  reviewing: { "zh-CN": "审核中", en: "Reviewing" },
  issued: { "zh-CN": "已开具", en: "Issued" },
  rejected: { "zh-CN": "已驳回", en: "Rejected" },
  cancelled: { "zh-CN": "已取消", en: "Cancelled" },
  canceled: { "zh-CN": "已取消", en: "Cancelled" },
  paid: { "zh-CN": "已支付", en: "Paid" },
  settled: { "zh-CN": "已结算", en: "Settled" },
  refunded: { "zh-CN": "已退款", en: "Refunded" },
  degraded: { "zh-CN": "已降级", en: "Degraded" },
  testing: { "zh-CN": "测试中", en: "Testing" },
  published: { "zh-CN": "已发布", en: "Published" },
  closed: { "zh-CN": "已关闭", en: "Closed" },
  suspended: { "zh-CN": "已暂停", en: "Suspended" },
  expired: { "zh-CN": "已过期", en: "Expired" },
};

export const statusLabel = (status: string | undefined | null, locale: "zh-CN" | "en"): string => {
  if (!status) return "—";
  const known = LABELS[status.toLowerCase()];
  if (known) return known[locale];
  return status.replace(/_/g, " ");
};
